"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAdminContextValue = exports.useAdminContextProvider = void 0;
const react_1 = __importDefault(require("react"));
const Api = __importStar(require("api"));
const antd_1 = require("antd");
const react_intl_1 = require("react-intl");
const types_1 = require("@src/types");
const socket_context_1 = require("@src/context/socket-context");
const useAppQuery_1 = require("@src/hooks/useAppQuery");
const queries_1 = require("@src/types/queries");
const react_query_1 = require("react-query");
const AdminContext = react_1.default.createContext({
    myOffers: {},
    areMyOffersLoading: false,
    companyInfo: {},
    isCompanyInfoLoading: false,
    companyInfoError: {},
    companyPremiumSettings: {},
    isOpenNotEnoughCreditsDialog: false,
    setIsOpenNotEnoughCreditsDialog: () => { },
    isCompanyPremiumActivatedDialogOpen: false,
    setIsCompanyPremiumActivatedDialogOpen: () => { },
});
const useAdminContextProvider = () => {
    const [isOpenNotEnoughCreditsDialog, setIsOpenNotEnoughCreditsDialog] = react_1.default.useState(false);
    const [isCompanyPremiumActivatedDialogOpen, setIsCompanyPremiumActivatedDialogOpen] = react_1.default.useState(false);
    const socket = (0, socket_context_1.useSocket)();
    const intl = (0, react_intl_1.useIntl)();
    const queryClient = (0, react_query_1.useQueryClient)();
    const { data: companyInfo = {}, isLoading: isCompanyInfoLoading, error: companyInfoError, } = (0, useAppQuery_1.useAppQuery)(queries_1.Queries.getCompany, Api.Company.getCompany, {
        onError: err => {
            console.error(err);
            antd_1.notification.error({
                message: intl.formatMessage({
                    id: 'global.notification_variants.error',
                }),
                description: intl.formatMessage({
                    id: 'global.notification_variants.something_went_wrong',
                }),
            });
        },
        refetchOnWindowFocus: true,
        refetchOnMount: true,
    });
    const { data: myOffers = {}, isLoading: areMyOffersLoading } = (0, useAppQuery_1.useAppQuery)(queries_1.Queries.getMyOffers, Api.Admin.getMyOffers, {
        onError: err => {
            console.error(err);
            antd_1.notification.error({
                message: intl.formatMessage({
                    id: 'global.notification_variants.something_went_wrong',
                }),
            });
        },
        refetchOnWindowFocus: true,
        refetchOnMount: true,
        staleTime: 0
    });
    react_1.default.useEffect(() => {
        socket.on(types_1.SocketEvents.UPDATE_COMPANY_INFO, () => queryClient.invalidateQueries(queries_1.Queries.getCompany));
    }, []);
    return {
        AdminContextProvider: AdminContext.Provider,
        value: {
            myOffers,
            areMyOffersLoading,
            companyInfo,
            isCompanyInfoLoading,
            companyInfoError,
            companyPremiumSettings: companyInfo.companyPremiumSettings,
            isOpenNotEnoughCreditsDialog,
            setIsOpenNotEnoughCreditsDialog,
            isCompanyPremiumActivatedDialogOpen,
            setIsCompanyPremiumActivatedDialogOpen,
        },
    };
};
exports.useAdminContextProvider = useAdminContextProvider;
const useAdminContextValue = () => {
    const context = react_1.default.useContext(AdminContext);
    return context;
};
exports.useAdminContextValue = useAdminContextValue;
